import { render, staticRenderFns } from "./EditSedimentRouting.vue?vue&type=template&id=5d84e5af&"
import script from "./EditSedimentRouting.vue?vue&type=script&lang=js&"
export * from "./EditSedimentRouting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports